import React from 'react';
import { history } from '../store'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { SubmissionError } from 'redux-form';
import Box from '../components/Box';
import LoadingProgress from '../components/LoadingProgress';
import { updateClient } from '../actions/customers'
import PasswordAssignForm from '../forms/PasswordAssignForm';

class PasswordAssignClientView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      successMessage: null,
      loading: false
    };
  }

  goTo(e) {
    history.push(`/`)
  }

  submit = (props) => {
    const searchParams = new URLSearchParams(this.props.location.search);
    const customerID = searchParams.get('un');

    this.setState({ loading: true });

    return this.props.updateClient(customerID, props)
      .then(response => {
        if (response.error) {
          throw new SubmissionError({
            _error: response.error.message,
            ...response.error.fields
          })
        }

        // Update state to show success message
        this.setState({
          successMessage: 'Tu contraseña se ha cambiado correctamente, puedes iniciar sesión.',
          loading: false
        });

        return response
      })
      .catch(error => {
        this.setState({ loading: false });
        // Handle other errors if needed
        console.error('Password assign error:', error);
      });
  };

  render() {
    const { successMessage, loading } = this.state;

    return (
      <div className="h-100 bg-login">
        <div className="container h-100">
          <div className="row justify-content-center align-items-center h-100">
            <div className="col col-lg-6">
              <div className="text-center mb-3">
                <img className="logo" src="/images/logo.svg" alt="Logo" />
              </div>
              <Box title="Cambio de contraseña" icon="key" bgcolor="white">
                {successMessage ? (
                  <div>
                    <div className="success-message mb-3">{successMessage}</div>
                    <button className="btn bg-vw-light text-white mr-1 mb-1" onClick={e => this.goTo(e)}>
                      Salir
                    </button>
                  </div>
                ) : (
                  loading ? (
                    <LoadingProgress />
                  ) : (
                    <PasswordAssignForm onSubmit={this.submit} />
                  )
                )}
              </Box>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  updateClient: bindActionCreators(updateClient, dispatch),
})

export default connect(() => ({}), mapDispatchToProps)(PasswordAssignClientView);
